import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import { dashboardQueryOptions } from './dashboard-query-options';

export interface TotalEnrollmentsOverTimeParams {
  startDate?: string; // yyyy-mm-dd
  endDate?: string; // 2025-12-31
  sessionId: string;
}

export interface TotalEnrollmentsOverTimeResponse {
  totalEnrollments: number;
}

export const getTotalEnrollmentsOverTimeAPI = async (
  params?: TotalEnrollmentsOverTimeParams,
) => {
  const response = await baseAPI.get<TotalEnrollmentsOverTimeResponse>(
    '/dashboard/metrics/total-enrollments-over-time',
    {
      params,
    },
  );
  return response.data;
};

export const useGetTotalEnrollmentsOverTime = (
  params?: TotalEnrollmentsOverTimeParams,
) => {
  return useQuery({
    ...dashboardQueryOptions,
    queryKey: QUERY_KEYS.TOTAL_ENROLLMENTS_OVER_TIME(params),
    queryFn: () => getTotalEnrollmentsOverTimeAPI(params),
    enabled: !!params?.sessionId,
  });
};
